import { FluentIcon } from "@fluentui/react-icons";
import { NavLink } from "react-router-dom";

interface MenuItemProps {
  label: string;
  href: string;
  Icon: FluentIcon;
}

function MenuItem({ label, href, Icon }: MenuItemProps) {
  return (
    <NavLink to={href}>
      {({ isActive }) => (
        <div
          className={
            "flex h-16 cursor-pointer" +
            (isActive ? " border-b-2 border-cyan-500" : "")
          }
        >
          <div className="flex items-center gap-2 pl-2 pr-4">
            {isActive ? (
              <Icon fontSize={20} className="text-cyan-600" />
            ) : (
              <Icon fontSize={20} className="text-cool-gray-600" />
            )}
            <div
              className={
                "font-medium " +
                (isActive ? "text-cyan-500" : "text-cool-gray-600")
              }
            >
              {label}
            </div>
          </div>
        </div>
      )}
    </NavLink>
  );
}

export default MenuItem;
